import styled from 'styled-components';

export const PageContainer = styled.div`
  margin: 0 1em;
  position: relative;
`;
